import React, { useState, useEffect } from 'react';
import {
    Card,
    Col,
    Form,
    Row,
    Button,
    Alert,
    Modal,
    OverlayTrigger,
    Tooltip
} from 'react-bootstrap';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';
import moment from 'moment';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import AddNotesModal from './AddNotesModal';
import paths from 'routes/paths';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';
import HoldRxGrid from './HoldRxGrid';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import { storeList } from 'components/common/StoreList';
import { useAppContext } from 'providers/AppProvider';
import { useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IndexHold = () => {
    const getActiveHoldReasons = () =>
        JSON.parse(localStorage.getItem('activeHoldReasonsData') || '[]');
    const getAllHoldReasons = () =>
        JSON.parse(localStorage.getItem('holdReasonsData') || '[]');
    const buildReasonObj = (reasons = getAllHoldReasons()) => {
        return reasons.reduce((acc, reason) => {
            acc[reason.id] = reason.reason;
            return acc;
        }, {});
    };

    const [filters, setFilters] = useState({
        group: '',
        facility: '',
        holdreason: '',
        holdstatus: '1',
        holdtype: '',
        holdsearch: '',
        store: '',
        delivery_cycle_date: ''
    });
    const [selectedStoreValue, setSelectedStoreValue] = useState('');
    const [searchParams] = useSearchParams();
    const fromParam = searchParams.get('from');
    const toParam = searchParams.get('to');
    const [startDate, setStartDate] = useState(
        fromParam
            ? moment(fromParam, 'MM/DD/YYYY').toDate()
            : moment().subtract(31, 'days').toDate()
    );
    const [endDate, setEndDate] = useState(
        toParam
            ? moment(toParam, 'MM/DD/YYYY').toDate()
            : moment().add(7, 'days').toDate()
    );
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [options, setOptions] = useState([]);
    const [reasonOptions, setReasonsOptions] = useState([
        { key: 'Select Reason', value: '' },
        ...getActiveHoldReasons()
    ]);
    const [holdreasonsresults, setReasonsResults] = useState(
        getActiveHoldReasons()
    );
    const [groupOptions, setGroupOptions] = useState([]);
    const [reasonObj, setReasonObj] = useState(buildReasonObj());
    const [showModal, setShowModal] = useState(false);
    const [holdId, setHoldId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [holdNotes, setHoldNotes] = useState([]);
    const [, setFacilitiesObj] = useState([]);
    const facilityList = JSON.parse(localStorage.getItem('facilitiesData')) || [];
    const [startDateError, setStartDateError] = useState('');
    const [endDateError, setEndDateError] = useState('');
    const [facilityobj, setFacilityObj] = useState({});
    const [showRxModal, setShowRxModal] = useState(false);
    const facilityResultsNew = JSON.parse(localStorage.getItem('facilitiesData'));
    const [storeOptions] = useState([
        { key: 'Select Store', value: '' },
        ...storeList
    ]);
    const columns = [
        {
            accessorKey: 'facility',
            header: 'Facility',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'delivery_cycle_date',
            header: 'Delivery/Cycle Date',
            meta: {
                headerProps: { className: 'text-900 ' }
            },
            sortingFn: (rowA, rowB) => {
                const a = moment(rowA.original.delivery_cycle_date, 'MM/DD/YY');
                const b = moment(rowB.original.delivery_cycle_date, 'MM/DD/YY');
                return a.isBefore(b) ? -1 : a.isAfter(b) ? 1 : 0;
            }
        },
        {
            accessorKey: 'patient',
            header: 'Patient',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'rx_id',
            header: 'Rx',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'drug',
            header: 'Drug',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'reason',
            header: 'Reason',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'status',
            header: 'Status',
            meta: {
                headerProps: { className: 'text-900 text-center' },
                cellProps: { className: 'text-center' }
            },
            cell: ({ row: { original } }) => (
                <div className="d-flex justify-content-center">
                    <Form.Select
                        className="form-select form-select-sm"
                        style={{ width: '100px' }}
                        value={original.get_hold_status}
                        onChange={e =>
                            handleHoldStatusChange(e, original.hold_id, original.rx_id)
                        }
                    >
                        <option value="1">Hold</option>
                        <option value="0">Unhold</option>
                    </Form.Select>
                </div>
            )
        },
        {
            accessorKey: 'hold_type',
            header: 'Hold Type',
            meta: {
                headerProps: { className: 'text-900 ' }
            }
        },
        // {
        //     accessorKey: 'hold_by_username', header: 'Hold By',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //         cellProps: { className: 'text-start' }
        //     },
        // },
        {
            accessorKey: 'hold_by_date',
            header: 'Hold Date',
            meta: {
                headerProps: { className: 'text-900' }
            },
            sortingFn: (rowA, rowB) => {
                const a =
                    rowA.original.hold_by_date !== '-'
                        ? moment(rowA.original.hold_by_date, 'MM/DD/YY')
                        : moment(0);
                const b =
                    rowB.original.hold_by_date !== '-'
                        ? moment(rowB.original.hold_by_date, 'MM/DD/YY')
                        : moment(0);
                return a.isBefore(b) ? -1 : a.isAfter(b) ? 1 : 0;
            },
            cell: ({ row: { original } }) =>
                original.hold_by_username !== '-' ? (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id={`tooltip-holdby-${original.hold_id}`}>
                                By: {original.hold_by_username}
                            </Tooltip>
                        }
                    >
                        <span
                            style={{ cursor: 'pointer', textDecoration: 'underline dotted' }}
                        >
                            {original.hold_by_date}
                        </span>
                    </OverlayTrigger>
                ) : (
                    <span>{original.hold_by_date}</span>
                )
        },
        // {
        //     accessorKey: 'called_date_reason',
        //     header: 'Called Date/Reason',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //         cellProps: { className: 'text-start' }
        //     },
        //     cell: ({ row: { original } }) => {
        //         const text = original.called_date_reason;
        //         const isTruncated = text && text !== '-' && text.length > 30;
        //         return isTruncated ? (
        //             <span
        //                 title={text}
        //                 style={{ cursor: 'pointer', color: '#2c7be5' }}
        //                 onClick={() => {
        //                     setCalledReasonFull(text);
        //                     setShowCalledReasonModal(true);
        //                 }}
        //             >
        //                 {truncateText(text)}
        //             </span>
        //         ) : (
        //             <span>{text || '-'}</span>
        //         );
        //     }
        // },
        {
            accessorKey: 'action',
            header: 'Message',
            meta: {
                headerProps: { className: 'text-900' }
            },
            cell: ({ row: { original } }) => (
                <FontAwesomeIcon
                    icon="eye"
                    tag="button"
                    className="cursor-pointer"
                    onClick={() => openNotesModal(original.hold_id, original.notes)}
                />
                // <IconItem
                //     tag="button"
                //     icon={['eye']}
                //     size="sm"

                // />
            )
        }
    ];

    const handleSearchClick = () => {
        setStartDateError('');
        setEndDateError('');

        if (!startDate || !endDate) {
            if (!startDate) setStartDateError('Start Date is required.');
            if (!endDate) setEndDateError('End Date is required.');
            return;
        }
        fetchHoldData();
    };

    const handleStartDateChange = date => {
        setStartDate(date);
        setStartDateError('');
    };

    const handleEndDateChange = date => {
        setEndDate(date);
        setEndDateError('');
    };

    const fetchHoldData = async () => {
        if (!startDate || !endDate) {
            if (!startDate) setStartDateError('Start Date is required.');
            if (!endDate) setEndDateError('End Date is required.');
            return;
        }
        setStartDateError('');
        setEndDateError('');
        setIsLoading(true);
        const groupList = JSON.parse(localStorage.getItem('groupsData'));

        setOptions([{ key: 'All facility', value: '' }, ...facilityResultsNew]);
        let temp = {};
        const groupResults = groupList.map(group => {
            const facilitiesForGroup = facilityResultsNew.filter(
                facility => facility.group_id === group.value
            );

            temp[group.value] = facilitiesForGroup.map(facility => ({
                name: facility.key,
                id: facility.value
            }));

            return { key: group.key, value: group.value };
        });

        setGroupOptions([{ key: 'Select Group', value: '' }, ...groupResults]);
        setFacilityObj(temp);
        const facilitiesMap = facilityResultsNew.reduce((acc, facility) => {
            acc[facility.value] = facility.key;
            return acc;
        }, {});
        setFacilitiesObj(facilitiesMap);
        try {
            const token = localStorage.getItem('accessToken');
            const payload = {
                start_date: moment(startDate).format('YYYY-MM-DD'),
                end_date: moment(endDate).format('YYYY-MM-DD')
            };

            const { data } = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/drugs/list-hold-drug/`,
                payload,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            const reasons = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/drugs/list-hold-reasons/`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );
            let reasonsResults = [];
            const getReasonsList = reasons.data.hold_reasons.data;
            if (getReasonsList.length > 0) {
                getReasonsList.forEach(val => {
                    if (val.is_active == 1) {
                        reasonsResults.push({
                            key: val.reason,
                            value: val.id
                        });
                    }
                });

                setReasonsOptions([
                    { key: 'Select Reason', value: '' },
                    ...reasonsResults
                ]);
                setReasonsResults(reasonsResults);
            }
            const reasonMap = {};
            reasons.data.hold_reasons.data.forEach(r => {
                reasonMap[r.id] = r.reason;
            });
            setReasonObj(reasonMap);

            const formattedData = data.drug_hold.data.map(item => ({
                hold_id: item.id,
                facility:
                    facilityList.find(f => f.value === item.facility_id)?.key || '',
                delivery_cycle_date: item.due_date
                    ? moment(item.due_date).format('MM/DD/YY')
                    : '',
                patient: `${item.patient_lastname}, ${item.patient_firstname}`,
                rx_id: item.pharmacy_order_id,
                drug: item.drug,
                reason:
                    item.holdreason_id != 0
                        ? reasonMap[item.holdreason_id] || ''
                        : item.holdreason_text,
                get_hold_status: item.is_hold,
                hold_type: item.is_cycle === 1 ? 'Cycle' : 'Daily',
                hold_by_date: item.is_hold
                    ? `${moment(item.hold_date).format('MM/DD/YY')}`
                    : '-',
                hold_by_username: item.is_hold ? `${item.hold_by_username}` : '-',
                called_date_reason: item.is_called
                    ? `${item.called_by_username} ${moment(item.called_date).format(
                        'MM/DD/YY'
                    )} ${item.called_note}`
                    : '-',
                get_called_reason: item.called_note || '',
                get_called_username: item.called_by_username || '',
                get_called_date: item.called_date || '',
                store_id: item.store_id,
                notes: item.notes
            }));
            const results = formattedData.filter(
                item => Number(item.get_hold_status) == 1
            );

            setData(formattedData);
            setFilteredData(results);
            applyFilters(formattedData);
        } catch (error) {
            toast.error('Error fetching hold data');
        } finally {
            setIsLoading(false);
        }
    };

    const handleHoldStatusChange = async (e, holdId, rxId) => {
        const newStatus = e.target.value;
        const token = localStorage.getItem('accessToken');
        const payload = { hold_id: holdId, is_hold: newStatus };

        const { data: response } = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/drugs/update-hold-status/`,
            payload,
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        );

        if (response.status) {
            toast.success(`Rx ${rxId} updated successfully`);

            // Update status in both data and filteredData
            setData(prevData =>
                prevData.map(item =>
                    item.hold_id === holdId
                        ? { ...item, get_hold_status: newStatus }
                        : item
                )
            );

            setFilteredData(prevFiltered =>
                prevFiltered.map(item =>
                    item.hold_id === holdId
                        ? { ...item, get_hold_status: newStatus }
                        : item
                )
            );
        }
    };

    const openNotesModal = (id, notes) => {
        setHoldId(id);
        setHoldNotes(notes || []);
        setShowModal(true);
    };

    const handleNotesUpdate = (id, updatedNotes) => {
        setData(prevData =>
            prevData.map(item =>
                item.hold_id === id ? { ...item, notes: updatedNotes } : item
            )
        );

        setFilteredData(prevFiltered =>
            prevFiltered.map(item =>
                item.hold_id === id ? { ...item, notes: updatedNotes } : item
            )
        );

        setHoldNotes(updatedNotes || []);
    };

    const openRxModal = () => {
        setShowRxModal(true);
    };

    const applyFilters = formattedData => {
        let filtered = formattedData || [...data];

        if (filters.facility) {
            filtered = filtered.filter(
                item =>
                    item.facility ==
                    facilityList.find(f => Number(f.value) === Number(filters.facility))
                        ?.key
            );
        }
        if (filters.holdreason) {
            filtered = filtered.filter(
                item => item.reason === reasonObj[filters.holdreason]
            );
        }
        if (filters.holdstatus) {
            filtered = filtered.filter(
                item => Number(item.get_hold_status) === Number(filters.holdstatus)
            );
        }
        if (filters.holdtype) {
            filtered = filtered.filter(
                item =>
                    item.hold_type === (filters.holdtype === '1' ? 'Cycle' : 'Daily')
            );
        }
        if (filters.holdsearch) {
            filtered = filtered.filter(
                item =>
                    item.patient
                        .toLowerCase()
                        .includes(filters.holdsearch.toLowerCase()) ||
                    item.facility.toLowerCase().includes(filters.holdsearch.toLowerCase())
            );
        }
        if (filters.store) {
            filtered = filtered.filter(
                item => Number(item.store_id) === Number(filters.store)
            );
        }
        if (filters.delivery_cycle_date) {
            filtered = filtered.filter(item =>
                moment(item.delivery_cycle_date).isSame(
                    filters.delivery_cycle_date,
                    'day'
                )
            );
        }
        setFilteredData(filtered);
    };

    const handleFilterChange = e => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleStoreFilterChange = e => {
        setSelectedStoreValue(e);
        const { value } = e;
        setFilters(prev => ({ ...prev, store: value }));
    };

    const handleSelectChange = (field, selected) => {
        setFilters(prev => ({ ...prev, [field]: selected?.value || '' }));
    };

    const {
        config: { isNavbarVerticalCollapsed },
        setConfig
    } = useAppContext();

    useEffect(() => {
        setConfig('isNavbarVerticalCollapsed', true);
        fetchHoldData();
        return () => {
            setConfig('isNavbarVerticalCollapsed', isNavbarVerticalCollapsed);
        };
    }, []);

    useEffect(() => {
        applyFilters();
    }, [filters]);

    const handleGroupChange = e => {
        if (e.value != '') {
            var groupFacilityResults = [];
            facilityobj[e.value].forEach(group => {
                groupFacilityResults.push({
                    key: group.name,
                    value: group.id
                });
            });
            setOptions([
                { key: 'Select Facility', value: '' },
                ...groupFacilityResults
            ]);
            filters.group = e.value;
            setFilters(filters);
        } else {
            setOptions([
                { key: 'Select Facility', value: '' },
                ...facilityResultsNew
            ]);
        }
    };

    const table = useAdvanceTable({
        data: filteredData,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Order-Hold', href: paths.indexHold, isActive: true }
    ];

    return (
        <>
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            <Card className="p-3">
                <div className="border rounded p-3 pb-4 mb-4">
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Label>Start Date</Form.Label>
                            <DatePicker
                                selected={startDate}
                                // onChange={(date) => setStartDate(date)}
                                onChange={handleStartDateChange}
                                dateFormat="MM/dd/yy"
                                className="form-control"
                            />
                            {startDateError && (
                                <div className="text-danger">{startDateError}</div>
                            )}
                        </Col>
                        <Col md={3}>
                            <Form.Label>End Date</Form.Label>
                            <DatePicker
                                selected={endDate}
                                // onChange={(date) => setEndDate(date)}
                                onChange={handleEndDateChange}
                                dateFormat="MM/dd/yy"
                                className="form-control"
                            />
                            {endDateError && (
                                <div className="text-danger">{endDateError}</div>
                            )}
                        </Col>
                        <Col md={4} className="d-flex align-items-end">
                            <Button
                                variant="primary"
                                onClick={handleSearchClick}
                                disabled={!startDate || !endDate}
                            >
                                Search
                            </Button>
                        </Col>
                        <Col md={2} className="d-flex align-items-end justify-content-end">
                            {data.length > 0 && !isLoading && (
                                <Button
                                    variant="outline-primary"
                                    className="ms-2"
                                    onClick={openRxModal}
                                >
                                    Hold Rx
                                </Button>
                            )}
                        </Col>
                    </Row>
                </div>
                <div className="filters-section border rounded pt-4 p-3 position-relative mb-2">
                    <div className="filter-heading">Filters</div>
                    <Form>
                        <Row className="mb-3">
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Group</Form.Label>
                                    <ThemedSelect
                                        name="group"
                                        placeholder="Select Group"
                                        options={groupOptions}
                                        classNamePrefix="react-select"
                                        getOptionLabel={option => option.key}
                                        getOptionValue={option => option.value}
                                        onChange={e => handleGroupChange(e)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Facility</Form.Label>
                                    <ThemedSelect
                                        name="facility"
                                        placeholder="Select Facility"
                                        options={options}
                                        classNamePrefix="react-select"
                                        getOptionLabel={option => option.key}
                                        getOptionValue={option => option.value}
                                        onChange={selected =>
                                            handleSelectChange('facility', selected)
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Hold Status</Form.Label>
                                    <Form.Select
                                        name="holdstatus"
                                        value={filters.holdstatus}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="">All</option>
                                        <option value="1">Hold</option>
                                        <option value="0">Unhold</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Hold Type</Form.Label>
                                    <Form.Select
                                        name="holdtype"
                                        value={filters.holdtype}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="">All</option>
                                        <option value="1">Cycle</option>
                                        <option value="0">Daily</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Hold Reason</Form.Label>
                                    <ThemedSelect
                                        name="holdreason"
                                        placeholder="Select Reason"
                                        options={reasonOptions}
                                        classNamePrefix="react-select"
                                        getOptionLabel={option => option.key}
                                        getOptionValue={option => option.value}
                                        onChange={selected =>
                                            handleSelectChange('holdreason', selected)
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Search</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Search patient or facility"
                                        name="holdsearch"
                                        value={filters.holdsearch}
                                        onChange={handleFilterChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Store</Form.Label>
                                    <ThemedSelect
                                        name="store"
                                        closeMenuOnSelect={true}
                                        placeholder="Select store"
                                        classNamePrefix="react-select"
                                        options={storeOptions}
                                        value={selectedStoreValue}
                                        getOptionLabel={option => option.key}
                                        getOptionValue={option => option.value}
                                        onChange={e => handleStoreFilterChange(e)}
                                        styles={{
                                            control: provided => ({
                                                ...provided,
                                                borderColor: '#ced4da',
                                                boxShadow: 'none',
                                                '&:hover': { borderColor: '#80bdff' }
                                            }),
                                            option: (provided, { isFocused, isSelected }) => ({
                                                ...provided,
                                                backgroundColor: isSelected
                                                    ? '#e9ecef !important'
                                                    : isFocused
                                                        ? '#f8f9fa !important'
                                                        : 'white !important',
                                                color: isSelected
                                                    ? '#212529 !important'
                                                    : '#212529 !important',
                                                cursor: 'pointer'
                                            }),
                                            singleValue: provided => ({
                                                ...provided,
                                                color: '#212529'
                                            })
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Delivery Date</Form.Label>
                                    <DatePicker
                                        selected={
                                            filters.delivery_cycle_date
                                                ? moment(filters.delivery_cycle_date).toDate()
                                                : null
                                        }
                                        onChange={date =>
                                            setFilters(prev => ({
                                                ...prev,
                                                delivery_cycle_date: date
                                                    ? moment(date).format('YYYY-MM-DD')
                                                    : ''
                                            }))
                                        }
                                        dateFormat="MM/dd/yy"
                                        className="form-control"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Card>
            {isLoading ? (
                <ShimmerUI />
            ) : filteredData.length === 0 ? (
                <Alert variant="info" className="text-center fw-bold">
                    No hold data found for the selected filters or date range.
                </Alert>
            ) : (
                <Card className="p-3">
                    <AdvanceTableProvider {...table}>
                        <Row>
                            <Col>
                                <AdvanceTable
                                    headerClassName="bg-200 text-nowrap align-middle text-center"
                                    rowClassName="text-nowrap align-middle text-center"
                                    tableProps={{
                                        size: 'sm',
                                        striped: true,
                                        className: 'fs-10 mb-0 overflow-hidden'
                                    }}
                                />
                            </Col>
                        </Row>
                        <div className="mt-3">
                            <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
                        </div>
                    </AdvanceTableProvider>
                </Card>
            )}
            <Modal
                show={showRxModal}
                onHide={() => setShowRxModal(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fs-8">Hold Rx</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    {showRxModal && (
                        <HoldRxGrid holdreasonsdata={holdreasonsresults} modalMode />
                    )}
                </Modal.Body>
            </Modal>
            <AddNotesModal
                show={showModal}
                setShow={setShowModal}
                holdid={holdId}
                notes={holdNotes}
                onNotesUpdate={handleNotesUpdate}
            />
        </>
    );
};

export default IndexHold;
